<agpr-dialog-container
    [id]="'wireContactEditor'"
    [showClose]="true"
    [heading]="'Amplify.wire.contactEditor.header'"
    (close)="closeDialog(null)"
    class="agpr-contactEditor-dialog"
>
    <div class="agpr-contactEditor-container">
        <div class="agpr-required-label">
            <span class="agpr-requiredAsterix"> * </span>
            {{ 'Amplify.wire.contactEditor.required' | localize }}
        </div>

        <div class="agpr-contactEditor-fields">
            <div>
                <agpr-text-input
                    [id]="'wire.contactBlockNameInput'"
                    [maxLength]="64"
                    [required]="true"
                    [bottomMargin]="false"
                    label="Amplify.wire.contactEditor.name"
                    placeholder="Amplify.wire.contactEditor.name.placeholder"
                    [(ngModel)]="name"
                    (blur)="validateContactName()"
                >
                </agpr-text-input>
                <agpr-form-message *ngIf="nameError">
                    {{ 'Amplify.wire.error.hasNoContactName' | localize }}
                </agpr-form-message>
            </div>
            <agpr-text-input
                [id]="'wire.contactPrimaryPhoneInput'"
                [maxLength]="64"
                [bottomMargin]="false"
                label="Amplify.wire.contactEditor.primaryPhone"
                placeholder="Amplify.wire.contactEditor.phone.placeholder"
                [(ngModel)]="primaryPhone"
            >
            </agpr-text-input>
            <agpr-text-input
                [id]="'wire.contactTitleInput'"
                [maxLength]="64"
                [bottomMargin]="false"
                label="Amplify.wire.contactEditor.title"
                placeholder="Amplify.wire.contactEditor.title.placeholder"
                [(ngModel)]="title"
            >
            </agpr-text-input>
            <agpr-text-input
                [id]="'wire.contactSecondaryPhoneInput'"
                [maxLength]="64"
                [bottomMargin]="false"
                label="Amplify.wire.contactEditor.secondaryPhone"
                placeholder="Amplify.wire.contactEditor.phone.placeholder"
                [(ngModel)]="secondaryPhone"
            >
            </agpr-text-input>
            <div>
                <agpr-text-input
                    [id]="'wire.contactBlockEmailInput'"
                    [maxLength]="128"
                    [bottomMargin]="false"
                    [required]="true"
                    label="Amplify.wire.contactEditor.email"
                    placeholder="Amplify.wire.contactEditor.email.placeholder"
                    [(ngModel)]="email"
                    (ngModelChange)="validateContactEmail()"
                >
                </agpr-text-input>
                <agpr-form-message *ngIf="emailError">
                    {{ 'Amplify.wire.error.hasNoContactEmail' | localize }}
                </agpr-form-message>
                <agpr-form-message *ngIf="emailFormatError">
                    {{ 'invalidEmailFormat' | localize }}
                </agpr-form-message>
            </div>

            <!-- hide image upload field as Newsdirect does not support it, keep the code here as in future we might need it for Newsfile or other partners -->
            <!-- <agpr-image-upload-field
                id="wire.contact.block"
                [field]="imageUploadBlock"
                (changes)="imageUploaded($event)"
            >
            </agpr-image-upload-field> -->
        </div>
    </div>

    <ng-template #footerLeft>
        <agpr-button
            label="cancel"
            (click)="closeDialog(null)"
        >
        </agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            label="Amplify.wire.contactEditor.updateButton"
            (click)="updateContact()"
            [style]="buttonTypes.primary"
        >
        </agpr-button>
    </ng-template>
</agpr-dialog-container>
